module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-28.eec16089.svg";